import { SECTION_TITLES } from '@common/constants/section-titles.constants';

export class RouteUtils {
  public handleCurrentRouteSection(route: string) {
    const routeArray = route.substring(1).split('?')[0].split('/');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const _item of routeArray) {
      const routeJoin = routeArray.join('/');
      if (SECTION_TITLES[routeJoin]) { return routeJoin; }
      routeArray.pop();
    }
    return '';
  }
}
